module.exports = __webpack_public_path__ + "img/scene_kids.73f5d694.webp";